import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import styled, { keyframes } from "styled-components";
import PropTypes from 'prop-types';
import * as SmartySDK from "smartystreets-javascript-sdk";
import authService from "../../services/authService";
import {
  formatUsPhoneInput,
  getUsPhoneState,
  normalizeUsPhone,
} from "../../services/usPhoneNumber";
import {
  buildSmartyAddressSuggestion,
} from "../../features/treatment-flow/addressSuggestion";
import { DEFAULT_SHIPPING_ADDRESS_SUB_QUESTIONS } from "../../features/treatment-flow/shippingAddressContract";
import { requiredGroupedFieldError } from "../../utils/questionValidation";
import { US_STATE_CODE_BY_NAME } from "../../constants/usStates";
import {
  fetchAddressAutocomplete,
  getAddressClientId,
  isAddressProxyEnabled,
  verifyAddressViaProxy,
} from "../../services/addressApi";

const US_FLAG_SRC = 'data:image/svg+xml;base64,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';

// ────────────────────────────────────────
// Animations
// ────────────────────────────────────────
const fadeSlideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// ────────────────────────────────────────
// Styled components
// ────────────────────────────────────────
const GroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const RowContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const SubQuestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-width: 0;
`;

const SubQuestionLabel = styled.label`
  color: var(--zyvgo-text-primary, #222222);
  font-size: 0.875rem;
  font-weight: 600;
  display: block;
  margin-bottom: 8px;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 16px 20px;
  border: 2px solid
    ${(props) =>
    props.$hasError
      ? "var(--zyvgo-error, #e74c3c)"
      : "var(--zyvgo-border, #e1e5e9)"};
  border-radius: var(--zyvgo-radius-sm, 6px);
  font-size: 1rem;
  font-family: var(--zyvgo-font-family);
  color: var(--zyvgo-text-primary, #222222);
  background-color: ${(props) => (props.disabled ? "#f5f5f5" : "#ffffff")};
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
  box-sizing: border-box;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "text")};

  &:focus {
    outline: none;
    border-color: ${(props) =>
    props.$hasError
      ? "var(--zyvgo-error, #e74c3c)"
      : "var(--zyvgo-primary, #222222)"};
    box-shadow: 0 0 0 3px
      ${(props) =>
    props.$hasError ? "rgba(231, 76, 60, 0.1)" : "rgba(34, 34, 34, 0.1)"};
  }

  &::placeholder {
    color: #999999;
  }

  &:disabled {
    background-color: #f5f5f5;
    color: #999999;
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

const SubFieldError = styled.div`
  color: var(--zyvgo-error, #e74c3c);
  font-size: 0.75rem;
  margin-top: 4px;
`;

const PhoneRow = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  min-width: 0;
  overflow: hidden;
`;

const PhoneFlagPrefix = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 10px;
  border: 2px solid
    ${(props) =>
    props.$hasError
      ? "var(--zyvgo-error, #e74c3c)"
      : "var(--zyvgo-border, #e1e5e9)"};
  border-right: none;
  border-radius: var(--zyvgo-radius-sm, 6px) 0 0 var(--zyvgo-radius-sm, 6px);
  background-color: #f8f9fa;
  font-size: 1rem;
  font-family: var(--zyvgo-font-family);
  color: var(--zyvgo-text-primary, #222222);
  white-space: nowrap;
  user-select: none;
`;

const PhoneInputField = styled.input`
  flex: 1;
  min-width: 0;
  padding: 16px 20px;
  border: 2px solid
    ${(props) =>
    props.$hasError
      ? "var(--zyvgo-error, #e74c3c)"
      : "var(--zyvgo-border, #e1e5e9)"};
  border-left: none;
  border-radius: 0 var(--zyvgo-radius-sm, 6px) var(--zyvgo-radius-sm, 6px) 0;
  font-size: 1rem;
  font-family: var(--zyvgo-font-family);
  color: var(--zyvgo-text-primary, #222222);
  background-color: ${(props) => (props.disabled ? "#f5f5f5" : "#ffffff")};
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "text")};

  &:focus {
    outline: none;
    border-color: ${(props) =>
    props.$hasError
      ? "var(--zyvgo-error, #e74c3c)"
      : "var(--zyvgo-primary, #222222)"};
    box-shadow: 0 0 0 3px
      ${(props) =>
    props.$hasError ? "rgba(231, 76, 60, 0.1)" : "rgba(34, 34, 34, 0.1)"};
  }

  &::placeholder {
    color: #999999;
  }

  &:disabled {
    background-color: #f5f5f5;
    color: #999999;
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

// Existing Patient Prompt Styles
const ExistingPatientPrompt = styled.div`
  background: linear-gradient(135deg, #FEF3E8 0%, #FDF8F3 100%);
  border: 1px solid #f4d2b1;
  border-radius: 12px;
  padding: 16px;
  margin-top: 12px;
  animation: ${fadeSlideIn} 0.3s ease-out;
`;

const PromptContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
  }
`;

const PromptText = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  
  .icon {
    font-size: 28px;
    flex-shrink: 0;
  }
  
  .message {
    color: #8B6F47;
    font-size: 0.9375rem;
    font-weight: 500;
    line-height: 1.4;
    text-align: left;
    
    strong {
      display: block;
      font-weight: 600;
      margin-bottom: 2px;
      color: #6B5435;
    }
  }
`;

const SignInButton = styled.button`
  background: var(--zyvgo-accent, #f4d2b1);
  color: #6B5435;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;
  
  &:hover {
    background: #f0c89d;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(244, 210, 177, 0.3);
  }
`;

const CheckingIndicator = styled.span`
  font-size: 0.75rem;
  color: #6B7280;
  margin-left: 8px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

// Consent checkbox (Personal Details)
const ConsentBlock = styled.div`
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid var(--zyvgo-border, #e1e5e9);
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;
const ConsentCheckbox = styled.input`
  width: 20px;
  height: 20px;
  margin-top: 2px;
  accent-color: var(--zyvgo-primary, #222222);
  cursor: pointer;
  flex-shrink: 0;
`;
const ConsentLabel = styled.label`
  font-size: 0.9375rem;
  color: var(--zyvgo-text-primary, #222222);
  line-height: 1.5;
  cursor: pointer;
  user-select: none;
`;
const PolicyLink = styled.a`
  color: var(--zyvgo-primary, #222222);
  text-decoration: underline;
  font-weight: 600;
  &:hover {
    text-decoration: none;
  }
`;

// Key stored in response for mandatory consent (personal_details only); excluded from payload when flattening
export const CONSENT_RESPONSE_KEY = '__consent_accepted';

// ────────────────────────────────────────
// Main Component
// ────────────────────────────────────────
const GroupedQuestion = React.forwardRef(
  (
    {
      question,
      value = {},
      onChange,
      error,
      preSelectedState,
      templateId,
      onLoginSuccess,
      onContinueAsNew,
      clientConfig,
      isAuthenticated = false,
      authenticatedPatient = null,
      prefillData = null,
      setShowLoginModal,
      onVerifyAddress,
      previewOnly = false,
      refreshPrefillOnPatientChange = false,
    },
    ref,
  ) => {
    const [groupedValues, setGroupedValues] = useState(value || {});
    const groupedValuesRef = useRef(groupedValues);
    groupedValuesRef.current = groupedValues;
    const [subErrors, setSubErrors] = useState({});
    const [existingEmailDetected, setExistingEmailDetected] = useState(false);
    const [detectedEmail, setDetectedEmail] = useState('');
    const [isCheckingEmail, setIsCheckingEmail] = useState(false);
    const emailLookupRequestRef = useRef(0);
    const [suggestions, setSuggestions] = useState([]);
    const [activeField, setActiveField] = useState(null);

    // Fallback sub-questions if none are provided by the backend
    const getDefaultSubQuestions = (type) => {
      if (type === 'personal_details') {
        return [
          { id: 'first_name', question_text: 'First Name', question_type: 'text', is_required: true, order_index: 0 },
          { id: 'last_name', question_text: 'Last Name', question_type: 'text', is_required: true, order_index: 1 },
          { id: 'email', question_text: 'Email Address', question_type: 'email', is_required: true, order_index: 2 },
          { id: 'phone', question_text: 'Phone Number', question_type: 'phone', is_required: true, order_index: 3 }
        ];
      }
      if (type === 'shipping_address') {
        return DEFAULT_SHIPPING_ADDRESS_SUB_QUESTIONS;
      }
      return [];
    };

    const subQuestions = (question.sub_questions && question.sub_questions.length > 0)
      ? question.sub_questions
      : getDefaultSubQuestions(question.question_type);

    const isShippingAddress = question.question_type === "shipping_address";
    const isPersonalDetails = question.question_type === "personal_details";

    // Policy viewer: relative path /policy/<policy_type> (no hardcoded host; works on any questionnaire URL)
    const getPolicyUrl = (policyType) => `/policy/${policyType}`;

    const clientDisplayName =
      clientConfig?.questionnaire_config?.company_name ||
      clientConfig?.name ||
      "our";

    // Track if we've prefilled to avoid race conditions
    const hasPrefilled = useRef(false);
    const prefilledPatientIdentity = useRef(null);
    const debounceRef = useRef(null);
    const autocompleteAbortRef = useRef(null);
    const addressProxyActive = isAddressProxyEnabled() && Boolean(getAddressClientId());
    const onChangeRef = useRef(onChange);
    onChangeRef.current = onChange;

    // ────────────────────────────────────────
    // Smarty Configuration
    // ────────────────────────────────────────
    const EMBEDDED_KEY = process.env.REACT_APP_SMARTY_EMBEDDED_KEY;
    const smartySdkEnabled = Boolean(EMBEDDED_KEY);

    const { autocompleteClient, streetClient } = useMemo(() => {
      if (!smartySdkEnabled) {
        return { autocompleteClient: null, streetClient: null };
      }
      const SmartyCore = SmartySDK.core;
      const smartySharedCredentials = new SmartyCore.SharedCredentials(EMBEDDED_KEY);
      return {
        autocompleteClient: new SmartyCore.ClientBuilder(smartySharedCredentials)
          .withLicenses(["us-autocomplete-pro-cloud"])
          .buildUsAutocompleteProClient(),
        streetClient: new SmartyCore.ClientBuilder(smartySharedCredentials)
          .buildUsStreetApiClient(),
      };
    }, [EMBEDDED_KEY, smartySdkEnabled]);

    // ────────────────────────────────────────
    // Smarty helpers
    // ────────────────────────────────────────
    const getSubIdByKeyword = (keywords) =>
      subQuestions.find((q) => {
        const txt = q.question_text?.toLowerCase() || "";
        return keywords.some((kw) => txt.includes(kw));
      })?.id;

    const streetId = getSubIdByKeyword(["street", "address"]);
    const aptId = getSubIdByKeyword(["apt", "suite", "unit", "secondary", "apartment"]);
    const cityId = getSubIdByKeyword(["city"]);
    const stateId = getSubIdByKeyword(["state"]);
    const zipId = getSubIdByKeyword(["zip", "postal", "zipcode"]);
    const countryId = getSubIdByKeyword(["country"]);

    const canonicalAddressField = (subId) => {
      if (!isShippingAddress || !subId) return null;
      if (subId === streetId) return "street_1";
      if (subId === aptId) return "street_2";
      if (subId === cityId) return "city";
      if (subId === stateId) return "state";
      if (subId === zipId) return "zip_code";
      if (subId === countryId) return "country";
      return null;
    };

    const withCanonicalAddressValue = (values, subId, subValue) => {
      const nextValues = { ...values, [subId]: subValue };
      const canonicalField = canonicalAddressField(subId);
      if (canonicalField) {
        nextValues[canonicalField] = (
          canonicalField === "country"
          && /^(united states|usa)$/i.test(String(subValue || "").trim())
        ) ? "US" : subValue;
      }
      return nextValues;
    };

    // ────────────────────────────────────────
    // Prefill form with authenticated patient data
    // ────────────────────────────────────────
    useEffect(() => {
      if (!isAuthenticated || !authenticatedPatient || !subQuestions?.length) {
        return;
      }
      const patientIdentity = String(
        authenticatedPatient.patient_id
        || authenticatedPatient.id
        || authenticatedPatient.email
        || "authenticated-patient",
      );
      if (
        hasPrefilled.current
        && !refreshPrefillOnPatientChange
      ) {
        return;
      }

      // Use API prefill_data when available (e.g. personal_details, shipping_address) merged with patient
      const personalPrefill = question?.question_type === 'personal_details' && prefillData?.personal_details
        ? { ...authenticatedPatient, ...prefillData.personal_details }
        : authenticatedPatient;
      const addressPrefill = question?.question_type === 'shipping_address' && prefillData?.shipping_address
        ? { ...authenticatedPatient, ...prefillData.shipping_address }
        : authenticatedPatient;
      const source = question?.question_type === 'shipping_address' ? addressPrefill : personalPrefill;

      const prefillValues = {};

      subQuestions.forEach((subQ) => {
        const questionText = (subQ.question_text || '').toLowerCase();
        let patientValue = null;

        // Personal Details - match by question text (use merged patient + prefill_data)
        if (questionText.includes('first name') && !questionText.includes('last')) {
          patientValue = source.first_name;
        } else if (questionText.includes('last name')) {
          patientValue = source.last_name;
        } else if (questionText.includes('email')) {
          patientValue = source.email;
        } else if (questionText.includes('phone')) {
          let phoneValue = (
            source.phone
            || source.phone_number
            || source.user?.phone
          );
          if (phoneValue && !phoneValue.startsWith('+')) {
            phoneValue = '+1' + phoneValue;
          }
          patientValue = phoneValue;
        } else if (questionText.includes('date of birth') || questionText.includes('dob')) {
          patientValue = source.date_of_birth;
        }
        // Shipping Address - match by question text or subQ.id
        else if (
          subQ.id === 'address_line_2' ||
          subQ.id === 'address2' ||
          subQ.id === 'street_2' ||
          subQ.id === 'apt' ||
          subQ.id === 'unit' ||
          subQ.id === 'suite' ||
          questionText.includes('apartment') ||
          questionText.includes('suite') ||
          questionText.includes('unit') ||
          questionText.includes('apt') ||
          questionText.includes('address line 2') ||
          questionText.includes('address 2')
        ) {
          patientValue = source.address_line_2 || source.address2 || source.address_line2 || source.apt || source.suite || source.unit || source.street_2;
        } else if (
          subQ.id === 'address' ||
          subQ.id === 'street' ||
          subQ.id === 'street_1' ||
          ((questionText.includes('street') || questionText.includes('address')) && !questionText.includes('email') && !questionText.includes('address 2') && !questionText.includes('line 2'))
        ) {
          patientValue = source.address || source.street || source.street_1 || source.street_address;
        } else if (subQ.id === 'city' || questionText.includes('city')) {
          patientValue = source.city;
        } else if (
          subQ.id === 'state' ||
          (questionText.includes('state') && !questionText.includes('zip') && !questionText.includes('united'))
        ) {
          let stateVal = source.state || source.state_code || source.state_abbreviation;
          if (stateVal && typeof stateVal === 'string') {
            stateVal = stateVal.trim();
            if (stateVal.length === 2) {
              stateVal = stateVal.toUpperCase();
            } else if (US_STATE_CODE_BY_NAME && US_STATE_CODE_BY_NAME[stateVal.toLowerCase()]) {
              stateVal = US_STATE_CODE_BY_NAME[stateVal.toLowerCase()];
            }
          }
          patientValue = stateVal;
        } else if (
          subQ.id === 'zip_code' ||
          subQ.id === 'zip' ||
          subQ.id === 'postal_code' ||
          questionText.includes('zip') ||
          questionText.includes('postal')
        ) {
          patientValue = source.zip_code || source.zip || source.postal_code;
        }

        if (patientValue !== null && patientValue !== undefined && patientValue !== '') {
          prefillValues[subQ.id] = patientValue;
        }
      });

      if (Object.keys(prefillValues).length > 0) {
        const isSamePatientRefresh = (
          hasPrefilled.current
          && prefilledPatientIdentity.current === patientIdentity
        );
        const currentValues = groupedValuesRef.current || {};
        const valuesToApply = isSamePatientRefresh
          ? Object.fromEntries(Object.entries(prefillValues).filter(([key]) => (
            currentValues[key] === undefined
            || currentValues[key] === null
            || currentValues[key] === ""
          )))
          : prefillValues;
        if (Object.keys(valuesToApply).length === 0) return;
        hasPrefilled.current = true;
        prefilledPatientIdentity.current = patientIdentity;
        const nextValues = isSamePatientRefresh
          ? { ...currentValues, ...valuesToApply }
          : valuesToApply;
        groupedValuesRef.current = nextValues;
        setGroupedValues(nextValues);
        onChangeRef.current(nextValues);
      }
    }, [
      isAuthenticated,
      authenticatedPatient,
      prefillData,
      subQuestions,
      question?.question_type,
      refreshPrefillOnPatientChange,
    ]);

    // ────────────────────────────────────────
    // Sync external value prop to internal state
    // ────────────────────────────────────────
    useEffect(() => {
      if (hasPrefilled.current) {
        const valueHasContent = value && typeof value === 'object' && Object.keys(value).length > 0;
        if (!valueHasContent) {
          console.log('🛑 [GroupedQuestion] Skipping value sync - prefilled and parent value is empty');
          return;
        }
      }

      if (value && typeof value === 'object') {
        const valueStr = JSON.stringify(value);
        const currentStr = JSON.stringify(groupedValues);
        if (valueStr !== currentStr) {
          setGroupedValues(value);
        }
      }
    }, [value, groupedValues]);

    // ────────────────────────────────────────
    // Pre-fill state field when preSelectedState is provided
    // ────────────────────────────────────────
    useEffect(() => {
      if (preSelectedState && !hasPrefilled.current) {
        const stateSubQ = subQuestions.find(sq =>
          sq.question_type === 'state' ||
          sq.question_text?.toLowerCase().includes('state')
        );

        if (stateSubQ) {
          setGroupedValues(prev => {
            if (!prev[stateSubQ.id]) {
              const newValues = {
                ...prev,
                [stateSubQ.id]: preSelectedState,
              };
              onChange(newValues);
              return newValues;
            }
            return prev;
          });
        }
      }
    }, [preSelectedState, subQuestions, onChange]);

    // ────────────────────────────────────────
    // Real-time validation (debounced)
    // ────────────────────────────────────────
    useEffect(() => {
      const timer = setTimeout(() => {
        const errors = {};
        subQuestions.forEach((subQ) => {
          const subValue = groupedValues[subQ.id]?.trim() || "";
          const label = subQ.question_text?.toLowerCase() || "";

          if (subValue) {
            if (label.includes("state")) {
              if (!/^[a-zA-Z]{2}$/.test(subValue)) {
                errors[subQ.id] = "State must be exactly 2 letters";
              }
            }
            if (label.includes("zip")) {
              if (!/^[a-zA-Z0-9]{1,10}$/.test(subValue)) {
                errors[subQ.id] = "Zip code must be max 10 alphanumeric characters";
              }
            }
            if (label.includes("email")) {
              if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(subValue)) {
                errors[subQ.id] = "Please enter a valid email address";
              }
            }
            if (label.includes("phone")) {
              const phoneState = getUsPhoneState(subValue);
              if (phoneState.status !== 'valid') {
                errors[subQ.id] = phoneState.status === 'incomplete'
                  ? "Please enter all 10 digits of your US phone number"
                  : "Please enter a valid US phone number";
              }
            }
          }
        });
        setSubErrors(errors);
      }, 300);

      return () => clearTimeout(timer);
    }, [groupedValues, subQuestions]);

    // ────────────────────────────────────────
    // Cleanup debounce on unmount
    // ────────────────────────────────────────
    useEffect(() => {
      return () => {
        if (debounceRef.current) {
          clearTimeout(debounceRef.current);
        }
      };
    }, []);

    // ────────────────────────────────────────
    // Check if this sub-question is the email field
    // ────────────────────────────────────────
    const isEmailField = useCallback((subQ) => {
      const text = (subQ.question_text || '').toLowerCase();
      const fieldMapping = (subQ.beluga_field_mapping || '').toLowerCase();
      const type = (subQ.question_type || '').toLowerCase();

      return (
        text.includes('email') ||
        fieldMapping === 'email' ||
        type === 'email'
      );
    }, []);

    // ────────────────────────────────────────
    // Handle email blur to check for existing account
    // ────────────────────────────────────────
    const handleEmailBlur = useCallback(async (email) => {
      const normalizedEmail = typeof email === 'string'
        ? email.trim().toLowerCase()
        : '';
      if (previewOnly || isAuthenticated || !normalizedEmail || !normalizedEmail.includes('@')) {
        return;
      }

      if (normalizedEmail === detectedEmail) {
        return;
      }

      const requestId = ++emailLookupRequestRef.current;
      setIsCheckingEmail(true);
      try {
        const result = await authService.checkEmailExists(normalizedEmail);
        if (requestId !== emailLookupRequestRef.current) return;

        if (result.exists) {
          setExistingEmailDetected(true);
          setDetectedEmail(normalizedEmail);
        } else {
          setExistingEmailDetected(false);
          setDetectedEmail('');
        }
      } catch (err) {
        if (requestId !== emailLookupRequestRef.current) return;
        setExistingEmailDetected(false);
      } finally {
        if (requestId === emailLookupRequestRef.current) {
          setIsCheckingEmail(false);
        }
      }
    }, [previewOnly, isAuthenticated, detectedEmail]);

    useEffect(() => {
      if (!isAuthenticated) return;
      emailLookupRequestRef.current += 1;
      setExistingEmailDetected(false);
      setDetectedEmail('');
      setIsCheckingEmail(false);
    }, [isAuthenticated]);

    // ────────────────────────────────────────
    // Build search string for Smarty autocomplete
    // ────────────────────────────────────────
    const buildSearchString = () => {
      const parts = [];
      if (groupedValues[streetId]) parts.push(groupedValues[streetId]);
      return parts.filter(Boolean).join(" ").trim();
    };

    // ────────────────────────────────────────
    // Debounced function for fetching address suggestions
    // ────────────────────────────────────────
    const fetchAddressSuggestions = useCallback(
      async (subId, search) => {
        if (!isShippingAddress || !subId) {
          return;
        }
        const proxyActiveNow =
          isAddressProxyEnabled() && Boolean(getAddressClientId());
        if (!smartySdkEnabled && !proxyActiveNow) {
          return;
        }

        setActiveField(subId);

        if (search.length < 5) {
          setSuggestions([]);
          return;
        }

        const clientId = getAddressClientId();
        if (proxyActiveNow && clientId) {
          autocompleteAbortRef.current?.abort();
          const controller = new AbortController();
          autocompleteAbortRef.current = controller;
          try {
            const results = await fetchAddressAutocomplete(clientId, search, {
              maxResults: 6,
              signal: controller.signal,
            });
            if (!controller.signal.aborted) {
              setSuggestions(results);
              return;
            }
          } catch (err) {
            if (err?.name === "AbortError") {
              return;
            }
            console.warn("Address proxy autocomplete failed, trying embedded Smarty:", err);
          }
        }

        if (!smartySdkEnabled || !autocompleteClient) {
          setSuggestions([]);
          return;
        }

        try {
          const lookup = new SmartySDK.usAutocompletePro.Lookup(search);
          lookup.maxResults = 6;

          const response = await autocompleteClient.send(lookup);
          setSuggestions(response.result || []);
        } catch (err) {
          console.error("Smarty Autocomplete failed:", err);
          setSuggestions([]);
        }
      },
      [isShippingAddress, smartySdkEnabled, autocompleteClient],
    );

    // ────────────────────────────────────────
    // Handle address input with debouncing
    // ────────────────────────────────────────
    const handleAddressInput = (subId, inputValue) => {
      const newValues = withCanonicalAddressValue(
        groupedValues,
        subId,
        inputValue,
      );
      setGroupedValues(newValues);
      onChange(newValues);

      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }

      debounceRef.current = setTimeout(() => {
        const search = buildSearchString();
        fetchAddressSuggestions(subId, search);
      }, 500);
    };

    // ────────────────────────────────────────
    // Apply selected address suggestion
    // ────────────────────────────────────────
    const applySuggestion = (suggestion) => {
      const updates = {};
      if (streetId) {
        const streetAddress = suggestion.streetLine
          ? suggestion.secondary
            ? `${suggestion.streetLine} ${suggestion.secondary}`
            : suggestion.streetLine
          : "";
        updates[streetId] = streetAddress;
      }
      if (aptId) updates[aptId] = suggestion.secondary || "";
      if (cityId) updates[cityId] = suggestion.city || "";
      if (stateId) updates[stateId] = suggestion.state || "";
      if (zipId) updates[zipId] = suggestion.zipcode || "";
      if (countryId) updates[countryId] = "United States";

      const newValues = Object.entries(updates).reduce(
        (values, [subId, subValue]) => withCanonicalAddressValue(
          values,
          subId,
          subValue,
        ),
        groupedValues,
      );
      setGroupedValues(newValues);
      onChange(newValues);

      setSuggestions([]);
      setActiveField(null);
    };

    // ────────────────────────────────────────
    // Look up a full address using Smarty Street API
    // ────────────────────────────────────────
    const lookupFullAddress = async (values = groupedValues) => {
      if (!isShippingAddress) {
        throw new Error("Smarty address lookup is unavailable");
      }
      const clientId = getAddressClientId();
      const proxyActiveNow =
        isAddressProxyEnabled() && Boolean(clientId);
      if (proxyActiveNow && clientId) {
        try {
          const verified = await verifyAddressViaProxy(clientId, {
            street: values[streetId] || "",
            apt: values[aptId] || "",
            city: values[cityId] || "",
            state: values[stateId] || "",
            zip: values[zipId] || "",
          });
          if (verified?.verified && verified?.normalizedAddress) {
            const normalized = verified.normalizedAddress;
            return {
              delivery_line_1: normalized.street,
              delivery_line_2: normalized.apt || "",
              components: {
                city_name: normalized.city,
                state_abbreviation: normalized.state,
                zipcode: normalized.zip,
              },
              analysis: { dpv_match_code: "Y" },
            };
          }
          if (verified && verified.verified === false) {
            return null;
          }
        } catch (err) {
          console.warn("Address proxy verify failed, trying embedded Smarty:", err);
        }
      }
      if (!smartySdkEnabled) {
        throw new Error("Smarty address lookup is unavailable");
      }
      const lookup = new SmartySDK.usStreet.Lookup();
      lookup.street = values[streetId] || "";
      lookup.secondary = values[aptId] || "";
      lookup.city = values[cityId] || "";
      lookup.state = values[stateId] || "";
      lookup.zipCode = values[zipId] || "";
      lookup.match = "enhanced";

      const response = await streetClient.send(lookup);
      const results =
        response.result ||
        (response.lookups &&
          response.lookups[0] &&
          response.lookups[0].result) ||
        [];
      return results[0] || null;
    };

    const suggestFullAddress = async (values = groupedValues) => {
      if (!isShippingAddress || (!smartySdkEnabled && !addressProxyActive)) return null;
      try {
        const match = await lookupFullAddress(values);
        if (!match) return null;
        return buildSmartyAddressSuggestion({
          values,
          fieldIds: {
            street: streetId,
            secondary: aptId,
            city: cityId,
            state: stateId,
            zip: zipId,
            country: countryId,
          },
          match,
        });
      } catch {
        console.warn("Smarty address suggestion unavailable.");
        return null;
      }
    };

    // Legacy questionnaires still require Smarty verification. Treatment
    // journeys call suggestFullAddress instead and never fail closed on it.
    const verifyFullAddress = async (values = groupedValues) => {
      if (!isShippingAddress) return true;

      try {
        const match = await lookupFullAddress(values);

        if (match) {
          const dpv =
            match.analysis?.dpvMatchCode ?? match.analysis?.dpv_match_code;

          if (dpv && ["Y", "S", "D"].includes(String(dpv).toUpperCase())) {
            const std = match.components || {};
            const updates = {};
            if (streetId)
              updates[streetId] = match.delivery_line_1 || values[streetId];
            if (cityId) updates[cityId] = std.city_name || values[cityId];
            if (stateId)
              updates[stateId] = std.state_abbreviation || values[stateId];
            if (zipId)
              updates[zipId] = std.plus4_code
                ? `${std.zipcode}-${std.plus4_code}`
                : std.zipcode || values[zipId];

            const correctedValues = { ...groupedValues, ...updates };
            setGroupedValues(correctedValues);
            onChange(correctedValues);

            setSubErrors((prev) => {
              const { addressVerified, ...rest } = prev;
              return rest;
            });

            return true;
          } else {
            setSubErrors((prev) => ({
              ...prev,
              addressVerified: "Address not recognized or not deliverable",
            }));
            return false;
          }
        } else {
          setSubErrors((prev) => ({
            ...prev,
            addressVerified: "Invalid address – please check details",
          }));
          return false;
        }
      } catch (err) {
        setSubErrors((prev) => ({
          ...prev,
          addressVerified: "Unable to verify address right now",
        }));
        return false;
      }
    };

    // ────────────────────────────────────────
    // Handle sub-question value changes
    // ────────────────────────────────────────
    const handleSubQuestionChange = (subQuestionId, subValue) => {
      const newValues = withCanonicalAddressValue(
        groupedValues,
        subQuestionId,
        subValue,
      );
      setGroupedValues(newValues);
      onChange(newValues);
    };

    // ────────────────────────────────────────
    // Get appropriate placeholder text
    // ────────────────────────────────────────
    const getPlaceholder = (subQ) => {
      const text = subQ.question_text?.toLowerCase() || '';
      if (text.includes('email')) return 'your.email@example.com';
      if (text.includes('phone')) return '(321) 123-4567';
      if (text.includes('zip')) return '12345';
      if (text.includes('city')) return 'City';
      if (text.includes('state')) return 'CA';
      if (text.includes('street') || text.includes('address'))
        return 'e.g: 4996 bailey hall ithaca, NY 14853';
      if (text.includes('apartment') || text.includes('suite') || text.includes('unit'))
        return 'Apt/Suite/Unit';
      if (text.includes('country')) return 'Country';
      return 'Your Response';
    };

    // ────────────────────────────────────────
    // Get appropriate input type
    // ────────────────────────────────────────
    const getInputType = (subQ) => {
      const type = subQ.question_type?.toLowerCase() || '';
      if (type === 'email') return 'email';
      if (type === 'phone') return 'tel';
      if (type === 'number') return 'number';
      return 'text';
    };

    // ────────────────────────────────────────
    // Check if question is a phone field
    // ────────────────────────────────────────
    const isPhoneQuestion = (subQ) =>
      subQ.question_type?.toLowerCase() === "phone";

    // ────────────────────────────────────────
    // Render individual sub-question
    // ────────────────────────────────────────
    const renderSubQuestion = (subQ) => {
      const isStateQ = subQ.question_type === 'state' || subQ.question_text?.toLowerCase().includes('state');
      const isEmail = isEmailField(subQ);
      const isDisabled = isStateQ && !!preSelectedState;
      const fieldError = subErrors[subQ.id];
      const isAddressField = isShippingAddress && subQ.id === streetId;

      return (
        <SubQuestionWrapper key={subQ.id}>
          <SubQuestionLabel>
            {subQ.question_text}
            {subQ.is_required && <span style={{ color: 'red' }}> *</span>}
            {isEmail && isCheckingEmail && (
              <CheckingIndicator>Checking...</CheckingIndicator>
            )}
          </SubQuestionLabel>

          {isPhoneQuestion(subQ) ? (
            <PhoneRow>
                  <PhoneFlagPrefix $hasError={!!fieldError}>
                    <span aria-label="United States" style={{ display: 'flex', alignItems: 'center' }}><img src={US_FLAG_SRC} alt="US" width="22" height="14" style={{borderRadius: '2px', display: 'block'}} /></span>
                    <span style={{ fontWeight: 500 }}>+1</span>
                  </PhoneFlagPrefix>
                  <PhoneInputField
                    type="tel"
                    inputMode="numeric"
                    value={formatUsPhoneInput(groupedValues[subQ.id])}
                    onChange={(e) => {
                      handleSubQuestionChange(subQ.id, normalizeUsPhone(e.target.value));
                    }}
                    placeholder="(321) 123-4567"
                    disabled={isDisabled}
                    $hasError={!!fieldError}
                    maxLength={16}
                    autoComplete="tel-national"
                  />
            </PhoneRow>
          ) : (
            <StyledInput
              type={getInputType(subQ)}
              value={groupedValues[subQ.id] || ""}
              onChange={(e) => {
                if (isAddressField) {
                  handleAddressInput(subQ.id, e.target.value);
                } else {
                  handleSubQuestionChange(subQ.id, e.target.value);
                }
              }}
              onBlur={isEmail ? (e) => handleEmailBlur(e.target.value) : undefined}
              placeholder={getPlaceholder(subQ)}
              disabled={isDisabled}
              $hasError={!!fieldError}
            />
          )}

          {/* Smarty suggestions dropdown */}
          {isAddressField &&
            activeField === subQ.id &&
            suggestions.length > 0 && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  right: 0,
                  background: "white",
                  border: "1px solid var(--zyvgo-border, #e1e5e9)",
                  borderRadius: "var(--zyvgo-radius-sm, 6px)",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  maxHeight: "220px",
                  overflowY: "auto",
                  zIndex: 10,
                  marginTop: "4px",
                }}
              >
                {suggestions.map((sug, idx) => (
                  <div
                    key={idx}
                    onClick={() => applySuggestion(sug)}
                    style={{
                      padding: "10px 14px",
                      cursor: "pointer",
                      borderBottom:
                        idx < suggestions.length - 1
                          ? "1px solid #f0f0f0"
                          : "none",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = "#f8f9fa")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = "white")
                    }
                  >
                    {`${sug.streetLine || ""}${sug.secondary ? ` ${sug.secondary}` : ""}, ${sug.city || ""}, ${sug.state || ""} ${sug.zipcode || ""}`.trim()}
                  </div>
                ))}
              </div>
            )}

          {/* Field-specific error message */}
          {fieldError && <SubFieldError>{fieldError}</SubFieldError>}
        </SubQuestionWrapper>
      );
    };

    // ────────────────────────────────────────
    // Render sub-questions in rows
    // ────────────────────────────────────────
    const renderRows = () => {
      const rows = [];
      for (let i = 0; i < subQuestions.length; i += 2) {
        const q1 = subQuestions[i];
        const q2 = subQuestions[i + 1];

        if (q2) {
          rows.push(
            <RowContainer key={`row-${i}`}>
              {renderSubQuestion(q1)}
              {renderSubQuestion(q2)}
            </RowContainer>
          );
        } else {
          rows.push(renderSubQuestion(q1));
        }
      }
      return rows;
    };

    // ────────────────────────────────────────
    // Expose verifyAddress function via ref
    // ────────────────────────────────────────
    React.useImperativeHandle(
      ref,
      () => ({
        getValues: () => groupedValues,
        getRequiredFieldError: () => requiredGroupedFieldError(
          question,
          groupedValues,
          subQuestions,
        ),
        suggestAddress: suggestFullAddress,
        verifyAddress: verifyFullAddress,
      }),
      [groupedValues, question, subQuestions, suggestFullAddress, verifyFullAddress],
    );

    // ────────────────────────────────────────
    // Render
    // ────────────────────────────────────────
    return (
      <>
        <GroupContainer>
          {renderRows()}

          {/* Mandatory consent checkbox - Personal Details only */}
          {isPersonalDetails && (
            <ConsentBlock>
              <ConsentCheckbox
                type="checkbox"
                id="consent-policy-telehealth"
                checked={!!groupedValues[CONSENT_RESPONSE_KEY]}
                onChange={(e) =>
                  handleSubQuestionChange(CONSENT_RESPONSE_KEY, e.target.checked)
                }
                aria-required="true"
              />
              <ConsentLabel htmlFor="consent-policy-telehealth">
                I agree to{" "}
                <PolicyLink
                  href={getPolicyUrl("terms_of_service")}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {clientDisplayName}&apos;s Terms
                </PolicyLink>
                {" and "}
                <PolicyLink
                  href={getPolicyUrl("privacy_policy")}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </PolicyLink>
                {" and consent to "}
                <PolicyLink
                  href={getPolicyUrl("consent_telehealth")}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Telehealth
                </PolicyLink>
                .
              </ConsentLabel>
            </ConsentBlock>
          )}

          {/* Welcome Back Prompt - Full Width */}
          {existingEmailDetected && !isAuthenticated && (
            <ExistingPatientPrompt>
              <PromptContent>
                <PromptText>
                  <span className="message">
                    <strong>Welcome back!</strong>
                    Sign in to pre-fill your information and save time.
                  </span>
                </PromptText>
                <SignInButton type="button" onClick={() => setShowLoginModal(true, detectedEmail)}>
                  Sign In
                </SignInButton>
              </PromptContent>
            </ExistingPatientPrompt>
          )}

          {error && (
            <div style={{ color: 'var(--zyvgo-error, #e74c3c)', fontSize: '0.875rem', marginTop: '8px' }}>
              {error}
            </div>
          )}

          {/* Address verification error */}
          {subErrors.addressVerified && (
            <SubFieldError>{subErrors.addressVerified}</SubFieldError>
          )}
        </GroupContainer>
      </>
    );
  }
);

GroupedQuestion.propTypes = {
  question: PropTypes.shape({
    sub_questions: PropTypes.array,
    question_text: PropTypes.string,
    question_type: PropTypes.string,
  }).isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  preSelectedState: PropTypes.string,
  templateId: PropTypes.string,
  onLoginSuccess: PropTypes.func,
  onContinueAsNew: PropTypes.func,
  clientConfig: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  authenticatedPatient: PropTypes.object,
  prefillData: PropTypes.object,
  setShowLoginModal: PropTypes.func,
  onVerifyAddress: PropTypes.func,
  previewOnly: PropTypes.bool,
  refreshPrefillOnPatientChange: PropTypes.bool,
};

GroupedQuestion.defaultProps = {
  value: {},
  isAuthenticated: false,
  authenticatedPatient: null,
  refreshPrefillOnPatientChange: false,
};

export default GroupedQuestion;
